import { Routes } from '@angular/router';

export const MARKETPLACE_ROUTES: Routes = [
  {
    path: 'marketplace',
    loadComponent: () =>
      import('./pages/marketplace-home/marketplace-home.component').then(
        (m) => m.MarketplaceHomeComponent,
      ),
  },
  {
    // Before the plain marketplace route so "preview" is not read as nothing.
    path: 'applications/:id/marketplace/preview',
    loadComponent: () =>
      import('./pages/marketplace-preview/marketplace-preview.component').then(
        (m) => m.MarketplacePreviewComponent,
      ),
  },
  {
    path: 'applications/:id/marketplace',
    loadComponent: () =>
      import('./pages/marketplace-form/marketplace-form.component').then(
        (m) => m.MarketplaceFormComponent,
      ),
  },
];
